import { GeneralMenu, GeneralCross } from "@fanduel/formation-react-icons";
import { useRouter } from "next/compat/router";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import Image from "@/components/Image";
import { NAV_LINK_CLICKED } from "@/constants/amplitude";
import { Menu } from "@/graphql/gql/graphql";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import MobileNavigation from "../MobileNavigation";
import Styles from "./MobileContainer.module.scss";

const MobileContainer = ({ menuItems }: Pick<Menu, "menuItems">) => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [activeSport, setActive] = useState("");
  const router = useRouter();
  const { logAmplitudeEvent } = useAmplitude();
  const pathName = usePathname();
  useEffect(() => {
    setMenuOpen(false);
    setActive("");
  }, [router?.asPath, pathName]);
  const [home, ...menu] = menuItems;
  return (
    <div className={Styles.container}>
      <div className={Styles.header}>
        <button
          aria-label="Nav Menu"
          onClick={() => setMenuOpen((currMenuState) => !currMenuState)}
          type="button"
        >
          {isMenuOpen ? (
            <GeneralCross
              data-testid="mobile-cross"
              height={34}
              width={34}
              color="coreGreyD3"
            />
          ) : (
            <GeneralMenu
              data-testid="mobile-menu"
              height={34}
              width={34}
              color="coreGreyD3"
            />
          )}
        </button>
        <Link
          href="/"
          aria-label="home"
          onClick={() =>
            logAmplitudeEvent(NAV_LINK_CLICKED, {
              "Link Text": "fd_logo",
              "Link URL": "/",
              Module: "navigation_menu",
              Menu: "mobile_nav",
            })
          }
        >
          <Image
            height={30}
            width={105}
            alt="Logo"
            src={home?.imageUrl ?? ""}
          />
        </Link>
        <div className={Styles.placeholder} />
      </div>
      <MobileNavigation
        menuItems={menu}
        isMenuOpen={isMenuOpen}
        activeSport={activeSport}
        setActive={setActive}
      />
    </div>
  );
};
export default MobileContainer;
